import { useRef, useState } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { AddConsultantTimeSheet } from "./AddConsultantTimeSheet";
import { ITimesheet } from "../../models/Timesheet";
import { IPurchaseOrder } from "../../models/PurchaseOrder";

export interface IModal {
    singleData: ITimesheet,
    open: boolean,
    po: IPurchaseOrder,
    recent: ITimesheet
}

interface IProps {
    is_Create?: boolean,
    is_Delete?: boolean,
    is_Update?: boolean,
    is_Export?: boolean,
    is_View?: boolean,
    po?: IPurchaseOrder,
    subVendor?: boolean,
    isConsultant?: boolean,
}

let xyz = {
    open: true,
    po: {
        pO_ID: 16941,
        prime_Vendor: 33791,
        sub_Vendor_ID: 67161,
        company_ID_Recruiter: 1,
        company_ID_Sales: 1,
    },
    recent: {

    },
    reload: false,
    setReload: () => { },
    singleData: {},
    consultant_ID: 184270,
    fromDate: null,
    pO_ID: 16941,
    toDate: null
}

export const ShowTimesheet = (permissions: IProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false, po: {}, recent: {} } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false, po: {}, recent: {} });
        setReload(!reload);
    };

    return (
        <>
            <AddConsultantTimeSheet singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} po={modal.po} recent={modal.recent} />
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload} byConsultant={0} po={permissions?.po || {}} subVendor={permissions?.subVendor || false}></Table>
            <Toast ref={toast} />
        </>
    );
}